import React from 'react';
import { StyleSheet, View } from 'react-native';
import { type ViewStyle } from '@expo/html-elements/build/primitives/View';
import { theme } from '@garnish/constants';

import { useResponsive } from '../../../../../hooks';

export const IngredientCardQuantityStepperContainer = (
  props: IngredientCardQuantityStepperContainerProps,
) => {
  const { children, style } = props;

  const { match } = useResponsive();
  const wrapperResponsiveStyles = match([null, null, null, styles.wrapperXL]);
  const wrapperStyles = [styles.wrapper, wrapperResponsiveStyles, style];

  return (
    <View style={wrapperStyles} pointerEvents="box-none">
      <View style={styles.innerContainer} pointerEvents="auto">
        {children}
      </View>
    </View>
  );
};

// ─── Styles ───────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  wrapper: {
    ...StyleSheet.absoluteFillObject,
    alignItems: 'center',
    justifyContent: 'center',
  },
  wrapperXL: {
    paddingHorizontal: theme.spacing['2'],
  },
  innerContainer: {
    minWidth: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing['3'],
    borderRadius: theme.radius.xxlarge,
    justifyContent: 'space-between',
    backgroundColor: theme.colors.CREAM,
    padding: theme.spacing['1'],
    ...theme.elevations['4'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type IngredientCardQuantityStepperContainerProps = {
  children: React.ReactNode;
  style?: ViewStyle;
};
